window.pages = {};
require("./pages/contact-us");
require("./pages/where-buy");
require("./pages/nutrition");
require("./pages/faq");
require("./pages/productlines");
require("./pages/recipes/show");
require("./pages/recipes/index");
require("./pages/calculator");
require("./pages/home");
require("./pages/search");
require("./pages/nutritional-articles");
require("./pages/product-lines-reciptes");

const currentRoute = document.body.getAttribute("page");
const currentPage = window.pages[currentRoute];
if (currentPage) {
    currentPage.init();
}
